module.exports = __webpack_public_path__ + "files/src/assets/files/new-certs/cert6.pdf";